import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreFormatsRoutes = [
  {
    path: 'formats',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Formats')
      },
      permissions: ['READ_RORE_FORMATS']
    },
    children: [
      {
        path: '',
        name: 'roreFormatsList',
        component: wrapLegacyRoute('roreFormatsController', 'list')
      },
      {
        path: 'create',
        name: 'roreFormatCreate',
        component: wrapLegacyRoute('roreFormatsController', 'create')
      },
      {
        path: ':formatId(\\d+)',
        name: 'roreFormatDetails',
        component: wrapLegacyRoute('roreFormatsController', 'details')
      }
    ]
  },
  {
    path: 'formats/types',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Format Types')
      },
      permissions: ['READ_RORE_FORMAT_TYPES']
    },
    children: [
      {
        path: '',
        name: 'roreFormatTypesList',
        component: wrapLegacyRoute('roreFormatTypesController', 'list')
      },
      {
        path: 'create',
        name: 'roreFormatTypeCreate',
        component: wrapLegacyRoute('roreFormatTypesController', 'create')
      },
      {
        path: ':typeId(\\d+)',
        name: 'roreFormatTypeDetails',
        component: wrapLegacyRoute('roreFormatTypesController', 'details')
      }
    ]
  }
];

export default roreFormatsRoutes;
